<script>
/*    Imports    */
    import { onMount, onDestroy, createEventDispatcher } from 'svelte';

/* Props komponenty KalendarMesic */

    export let VybraneDatum = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    
    export let TerminyProDanyMesic = [];
    
    $: mesic = new Date(new Date(TerminyProDanyMesic[0]?.start_time).getFullYear(), new Date(TerminyProDanyMesic[0]?.start_time).getMonth(), 1);

/* Vlastnosti komponenty KalendarMesic */
    export let PrepinacVyberuData = 0;

    export let displayed = true;

    const dispatch = createEventDispatcher();

/* Funkce komponenty KalendarMesic */

    /* Při vytvoření komponenty */
    onMount(() => 
        {

        }
    )

    /* Při odebírání komponenty */
    onDestroy(() =>
        {

        }
    )

    /**
     * Procedura pro změnu uživatelova výběru data v daném měsíci
     * 
     * @param {Date} HodnotaData Hodnota data, která se má nově nastavit
     * 
     * @returns {void} - Procedura
     */
    function ZmenVybraneDatum(HodnotaData) 
    {  
        // console.log("Změna data:", HodnotaData, VybranePocatecniDatum, VybraneKoncoveDatum);
        
        VybraneDatum = new Date(HodnotaData);
    }

    /**
     * @todo Přidat funkci na získání informací o daném měsíci (await API)
     *  
     * Vytvoří array s iformacemi pro tlačítka 
     * + Primárně datum dne, které tlačítko vyjadřuje
     * + Kapacita pro daný den
     * + Využitá kapacita daného dne
     * + Zbývající kapacita daného dne v měsíci
     * 
     * @param {Date} prvniDenMesice - Označuje první den zobrazovaného měsíce
     * @param {Array<Object>} stavRezervaci - Stáhnuté rezervace z API
     * 
     * @returns {Array<Date>} - Vrátí pole se všemi dny v měsíci, nebo null pro offset daného dne v týdnu 
     */
    function ZiskatDnyVMesici(prvniDenMesice, stavRezervaci) 
    {
        // console.log("stav Rezervaci", stavRezervaci);
        const filtered = Object.values(
            stavRezervaci.reduce((acc, item) => {
                const date = item.start_time.split(" ")[0];

                if (!acc[date]) {
                    acc[date] = {
                        start_time: item.start_time,
                        reserved_count: item.reserved_count ?? 0,
                        capacity: item.capacity ?? 0
                    };
                } else {
                    acc[date].reserved_count += item.reserved_count ?? 0;
                    acc[date].capacity += item.capacity ?? 0;
                }

                return acc;
            }, {})
        );


        // console.log("filtered", filtered);


        const [rok, mesic] = [prvniDenMesice.getFullYear(), prvniDenMesice.getMonth()];

        const PrvniDen = new Date(rok, mesic, 1);
        const PosledniDen = new Date(rok, mesic + 1, 0);

        const Dny = [];

        // Začátek týdne pondělí
        let PrvniDenTydne = (PrvniDen.getDay() + 6) % 7;
        for (let i = 0; i < PrvniDenTydne; i++) 
        {
            // Přidá mezeru pro posunutí vykreslování
            Dny.push(null);
        }

        // 

        for (let den = 1; den <= PosledniDen.getDate(); den++) 
        {
            const d = new Date(rok, mesic, den);
            const rezervaceVDen = filtered.filter((el) => 
                el.start_time.startsWith(FormatovatDatumProAPI(d))
            );

            let reserved_count = 0;
            let capacity = 0;

            if (rezervaceVDen.length > 0) {
                reserved_count = rezervaceVDen.reduce((sum, el) => sum + (el.reserved_count ?? 0), 0);
                capacity = rezervaceVDen.reduce((sum, el) => sum + (el.capacity ?? 0), 0);
            }

            const data = {
                datum: d,
                reserved_count: reserved_count,
                capacity: capacity
            };

            Dny.push(data);
        }


        // console.log(Dny);

        return Dny;
    }


    /**
     * @description Funkce vypočítá, zda je rok, měsíc a den u obou datumů stejný
     * 
     * @param {Date} date1 - první datum k porovnání
     * @param {Date} date2 - druhé datum k porovnání
     * 
     * @returns {Bool} true, pokud je rok, měsíc a den stejný u dvou dat
     */
    function JsouDataStejna(date1, date2) 
    {
        return date1.getFullYear() === date2.getFullYear() &&
            date1.getMonth() === date2.getMonth() &&
            date1.getDate() === date2.getDate();
    }

    /**
     * @description Formátuje datum pro API v požadovaném formátu DD-MM-YYYY
     * 
     * @param {Date} datum - Datum, které se má formátovat pro API
     * 
     * @returns {String} - Formátované datum ve tvaru DD-MM-YYYY
     */
    function FormatovatDatumProAPI(datum) 
    {
        const dd = String(datum.getDate()).padStart(2, '0');
        const mm = String(datum.getMonth() + 1).padStart(2, '0');
        const yyyy = datum.getFullYear();
        const final = `${yyyy}-${mm}-${dd}`;
        // console.log("Formátované datum pro API:", final);

        return final;
    }
</script>

<div class="kalendar-mesic" class:kalendar-mesic-mimo={!displayed}>
    <div class="label-mesic">
        {mesic.toLocaleString('cs-CZ', { month: 'long', year: 'numeric' })}
    </div>
    <div class="kalendar-mrizka">
        <div class="kalendar-dny-tydne">
            <span>Po</span>
            <span>Út</span>
            <span>St</span>
            <span>Čt</span>
            <span>Pá</span>
            <span>So</span>
            <span>Ne</span>
        </div>
            <div class="kalendar-dny-na-vyber">
                {#each ZiskatDnyVMesici(mesic, TerminyProDanyMesic) as den}
                    {#if den}
                        <button
                            data-value={FormatovatDatumProAPI(den?.datum)}
                            class:selected = {
                                JsouDataStejna(den?.datum, VybraneDatum)
                            }                        
                            class:durationSelected = {
                                (den?.datum.getTime() > VybraneDatum.getTime() && den?.datum.getTime() < VybraneDatum.getTime())
                            }
                            class:notBookable = {
                                (new Date(den?.datum.toDateString()) < new Date(new Date().toDateString())) || den?.reserved_count >= den?.capacity
                            }
                            class:reducedCapacity = {
                                den?.reserved_count > 0 && den?.reserved_count < den?.capacity
                            }
                            disabled = {
                                (new Date(den?.datum.toDateString()) < new Date(new Date().toDateString()))
                            }
                            on:click|preventDefault = {
                                () => {
                                    // console.log("Změna na: ", den?.datum);
                                    ZmenVybraneDatum(den?.datum);
                                    // dispatch("change");
                                }
                            }
                        >{den?.datum?.getDate()}</button>
                    {:else}
                        <span class="prazdne" />
                    {/if}
                {/each}
            </div>
    </div>
</div>

<style>
.kalendar-mesic 
{
    flex: 1;
    background: #f9f9f9;
    border-radius: 8px;
    padding: 1em;
    box-shadow: 0 2px 8px #0001;
}
.label-mesic 
{
    text-align: center;
    font-weight: bold;
    margin-bottom: 0.5em;
    color: #444;
}
.kalendar-mrizka 
{
    display: flex;
    flex-direction: column;
}
.kalendar-dny-tydne 
{
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    text-align: center;
    font-size: 0.9em;
    color: #888;
    margin-bottom: 0.3em;
}
.kalendar-dny-na-vyber 
{
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 0.2em;
}
.kalendar-dny-na-vyber button 
{
    /* background: #fff; */
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 0.5em 0;
    cursor: pointer;
    transition: background 0.2s;
    /* user unable to highlight selected */
    user-select: none;
    color: #333;
    background: limegreen
}

.kalendar-dny-na-vyber button:hover 
{
    background: #6ea1d4 !important;
    color: #fff;
    border-color: #6ea1d4 !important;
}

.kalendar-dny-na-vyber button.selected 
{
    background: #1976d2 !important;
    color: #fff;
    border-color: #1976d2;
}

.kalendar-dny-na-vyber button.durationSelected 
{
    background: #4181c0 !important;
    color: #fff;
    border-color: #4181c0 !important;
}

.kalendar-dny-na-vyber button.reducedCapacity 
{
    background: limegreen;
    color: #444;
    border-color: limegreen;
}

.kalendar-dny-na-vyber button.notBookable 
{
    background: lightcoral !important;
    color: #5a5a5a;
    border-color: lightcoral !important;
}

.kalendar-dny-na-vyber button:disabled 
{
    background: #eee;
    color: #bbb;
    cursor: not-allowed;
}

.kalendar-mesic-mimo 
{
    display: none;
}
</style>